import { combineReducers } from 'redux';

import App from './App';
import Header from './Header';
import GoogleMap from './GoogleMap';
import Places from './Places';
import CancelBtn from './CancelBtn';
import RouteBtn from './RouteBtn';
import StartOverBtn from './StartOverBtn';
import Directions from './Directions';
import Vehicle from './Vehicle';
import Superchargers from './Superchargers';
import Autocomplete from './Autocomplete';
import AddStopBtn from './AddStopBtn';
import Tooltip from './Tooltip';
import RouteSummary from './RouteSummary';
import GasSavings from './GasSavings';
import ErrorMsg from './ErrorMsg';
import DestinationChargers from './DestinationChargers';

const TripPlannerApp = combineReducers({
  App,
  Header,
  GoogleMap,
  Places,
  RouteBtn,
  CancelBtn,
  StartOverBtn,
  Directions,
  Vehicle,
  Superchargers,
  Autocomplete,
  AddStopBtn,
  Tooltip,
  RouteSummary,
  GasSavings,
  ErrorMsg,
  DestinationChargers,
});

export default TripPlannerApp;
